export default "__VITE_ASSET__tbApiwLB__"